module.exports = __webpack_public_path__ + "static/media/1005258.3c6a37a8.jpg";